// styles of star component
export enum StarRatingViewKind {
    CardStars = 'CardStars',
    Summary = 'Summary',
    Reviews = 'Reviews',
    Website = 'Website'
}
